(function() {
	'use strict';

	angular.module('taskApp').controller('CommonTaskController',
			CommonTaskController);

	CommonTaskController.$inject = [ '$scope', '$state', 'CommonTask', '$log',
			'$resource','GLOBAL_URL','NgTableParams','$filter','FORMAT_DATE','$window','$base64','WF_TASK', '$cookies', '$timeout', 'CommonService'];

	function CommonTaskController($scope, $state, CommonTask, $log, $resource,
			GLOBAL_URL, NgTableParams, $filter, FORMAT_DATE, $window, $base64,
			WF_TASK, $cookies, $timeout, CommonService) {
		var commonTaskCtr = this;
		commonTaskCtr.transactionTypes = [];
		commonTaskCtr.fromCreatedDate = new Date();
		commonTaskCtr.toCreatedDate = new Date();
		var self = $scope;

		self.title = 'Danh sách công việc chung';

		var currentDate = new Date();
		currentDate.setHours(0,0,0,0)
		var tDate = new Date("04/23/2024")
		if(tDate <= currentDate
			&& document.getElementById("fileTemplateHotlink") != null
			&& document.getElementById("fileTemplateHotlink") != undefined)
		{
			document.getElementById("fileTemplateHotlink").style.display = "none";
		}

		commonTaskCtr.popupDate = {'fromCreatedDate': false, 'tocreatedDate': false};
		
		commonTaskCtr.transactionTypes = CommonService.query({masterurl:'get-all-transaction-type'});
    	
		self.WF_TASK = WF_TASK;
		
		commonTaskCtr.transactionURLs = CommonService.query({masterurl:'get-transaction-url'});
    	commonTaskCtr.getTransactionURL = function (code) {
    		return _.result(_.find(commonTaskCtr.transactionURLs, function(obj) {
    		    return obj.code === code;
    		}), 'name');
    	}
    	
		 $timeout(function(){
			 var expirationCookie =$cookies.get('X-PRUGAGreatApp-ldap-expiration');
			 
			 if(expirationCookie){
				 $scope.addAlert(expirationCookie,'warning', null, null);
				 $cookies.remove('X-PRUGAGreatApp-ldap-expiration');
			 }
		 }, 500);
		
		commonTaskCtr.tableParams = new NgTableParams({
			page: 1,
			count: 20,
			sorting: { 'taskInstance.createdDate': 'desc' } 
		},
		{
			total: 0,
			counts: [20, 40, 80],
			defaultSort: 'desc',
			getData: function(params) {
	    		var param = {};
	    		param['page'] = params.page();
	    		param['size'] = params.count();
	    		param['sort'] = params.sorting();
	    		if (commonTaskCtr.fromCreatedDate) {
	    			param['fromCreatedDate'] = $filter('date')(commonTaskCtr.fromCreatedDate, FORMAT_DATE);
	    		}
	    		
	    		if (commonTaskCtr.toCreatedDate) {
	    			param['toCreatedDate'] = $filter('date')(commonTaskCtr.toCreatedDate, FORMAT_DATE);
	    		}
	    		if (commonTaskCtr.customerName) {
	    			param['customerName'] = commonTaskCtr.customerName
	    		}
	    		if (commonTaskCtr.policyNum) {
	    			param['policyNum'] = commonTaskCtr.policyNum
	    		}
	    		if (commonTaskCtr.txnId) {
	    			param['txnId'] = commonTaskCtr.txnId
	    		}
	    		if (commonTaskCtr.transactionType) {
	    			param['txnType'] = commonTaskCtr.transactionType
	    		}
	    		return CommonTask.query(param).$promise.then(function(result) {
	    			params.total(result.totalElements);
					return result.content;;
				});
			 }
		});
		

    	commonTaskCtr.clickPopupDate = function (name) {
    		commonTaskCtr.popupDate[name] = !commonTaskCtr.popupDate[name];
    	}
    	
    	commonTaskCtr.openPolicyInfo =  function(policyNum) {
    		var uri = null;
    		var number = null;
    		if (policyNum) {
    			uri = 'ga/history/#/constractInfo/';
    			number = $base64.encode(policyNum);
    		}
    		uri = uri.concat(number);
    		$window.open(GLOBAL_URL + uri, '_self')
    	}
    	
		commonTaskCtr.inState = function(state) {
			return $state.includes(state);
		}
		
		commonTaskCtr.search = function () {
			commonTaskCtr.tableParams.page(1);
    		commonTaskCtr.tableParams.reload();
    	}

		//load common task
		commonTaskCtr.loadCommonTask = function() {
			CommonTask.query({

			}, function(result) {
				self.taskInstances = result;
			});
		}
		//commonTaskCtr.loadCommonTask();

		commonTaskCtr.redirectTo = function (url, txnId, taskId, workFlowCode){
			if(url != '' && txnId != '' && taskId != '') {
				if(workFlowCode == 'PAYMENT_VOUCHER' || workFlowCode == 'PAYMENT_OTHER_SYS' || workFlowCode == 'PAYMENT_ME') {
					$window.open(commonTaskCtr.getTransactionURL('TRANSACTION_PAYMENT') + '/' + url + '/' + $base64.encode(txnId) + '/' + $base64.encode(taskId), '_self');
				} else if (workFlowCode === 'FFG_BILLING_CHANGE') {
					$window.open(commonTaskCtr.getTransactionURL('TRANSACTION_BILLING_CHANGE') + '/' + url + '/' + $base64.encode(txnId) + '/' + $base64.encode(taskId), '_self');
				} else if (workFlowCode === 'FFG_GO_ABROAD') {
					$window.open(commonTaskCtr.getTransactionURL('TRANSACTION_GO_ABROAD') + '/' + url + '/' + $base64.encode(txnId) + '/' + $base64.encode(taskId), '_self');
				} else if (workFlowCode === 'GA_INVESTMENT_PLUS') {
					$window.open(commonTaskCtr.getTransactionURL('GA_INVESTMENT_PLUS') + '/' + url + '/' + $base64.encode(txnId) + '/' + $base64.encode(taskId), '_self');
				} else if (workFlowCode === 'GA_FUND_SWAP') {
					$window.open(commonTaskCtr.getTransactionURL('TRANSACTION_FUND_SWAP') + '/' + url + '/' + $base64.encode(txnId) + '/' + $base64.encode(taskId), '_self');
				} else {
					$window.open(GLOBAL_URL + url + '/' + $base64.encode(txnId) + '/' + $base64.encode(taskId), '_self');
				}
			}
		};
		//take task to me
		commonTaskCtr.takeAndOpenTask = function(url,taskId,txnId, workFlowCode) {
			var Task = $resource(GLOBAL_URL+'api/wf/take-task', {}, {
				'take' : {
					method : 'GET'
				}
			});
			var task = Task.take({
				taskId : taskId
			}, function(result) {
				commonTaskCtr.redirectTo(url, txnId, taskId, workFlowCode);
			});

		};

	}
})();
